
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
// reactstrap components
import {
  Button, InputGroup, InputGroupText, Spinner,
  Card,Badge,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,Table,
  Col,
} from "reactstrap";
import {fieldvalidator, filenamevalid, alphanum, alpha, numtests, numdtest,
  floattest, numtest} from '../../../helpers/validate'
import {customStyles} from '../../../helpers/mycomps'
  

import dlogo from "../../images/Logo.jpeg"


function Currency(props) {
  const [showProcessing , setShowProcessing] = useState(false)
  const [alert, setAlert] = React.useState(null);
  const [curval, setCurval] = useState({cid : "1", name : "Dhm", value : "1", country : "United Arab Emirates", symbol :"Dhm"})
  const [curlist, setCurlist] = useState([])
 
 
  const submitUpdate = (cid) => {
    if(fieldvalidator(curval.value)){
      props.swal("Required Fields are EMPTY!")
      return
    }


    setShowProcessing(true)
    props.API.post(`tenant/updcurrency`, {curval : curval},{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        props.swal(res.data.message)
        fcurrency()
        setShowProcessing(false)
     
      }).catch(function (error) {
        setShowProcessing(false)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
        }else{
          props.swal("Error updating currency data.")
        }
         
      }) 
   
    }
  

  const cinputConfirmAlert = (xcc) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure that you want update?",
      icon: "warning",
      dangerMode: true,
    })
    .then(willDelete => {
      if (willDelete) {
        submitUpdate()
      }
    });
  }

// fetch currency for update 
  const fcurrency = () => {
 
    setShowProcessing(true)
    props.API.get(`tenant/getcurrency`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
        setShowProcessing(false)
        setCurlist(res.data.data.map((x, key) => {
            return {
                key : key,
                value : x.cid , label : x.country,
                name :x.name, country : x.country,
                symbol : x.symbol, amount : x.value
            }
        }))

                         
      }).catch(function (error) {
        setShowProcessing(false)
        console.log(error)
        if(error.response.status === 401){
          props.swal("Unauthorized, please login again.").then(t => {
              props.history.push(`/auth/login`)
          })   
      }else{
        props.swal("Error fetching currency data")
      }
          
      }) 
  }

  

useEffect(() =>{ 
  fcurrency()
},[])

  return (
    <>
    
    {showProcessing && props.Spin}
    <div className="content">
                <Row>
                    <Col>
                    <Card >
                      <CardHeader>
                      <h6 className="title">Currency Value Update  </h6>
                      </CardHeader>
                      <CardBody>
                    
                        <Row>
                            <Col md="4">
                             <Row>
                                <Col md="8">
                                <Select options={curlist} styles={customStyles} 
                                   //value={{label : area.en + ' '+  area.ar , value : area.cityCode}} 
                                   onChange={e=> {
                                    setCurval(
                                        {cid : e.value, name : e.name, value : e.amount, country : e.country, symbol : e.symbol}
                                    )
                                   }}
                                   />
                                </Col>
                                <Col md="4">
                                    <center>
                                <Button  style={{marginTop : 0}} 
                                   onClick={x => {
                                    fcurrency()
                                }}> <i className="fa fa-refresh" aria-hidden="true"/></Button>
                              </center>
                                </Col>
                             </Row>
                           
                            <Row>
                                <Col md="8">
                                <FormGroup>
                               <label>{curval.name}</label>
                               <InputGroup>
                                   <Input
                                      maxLength={20}
                                       type="text"
                                       value = {curval.value}
                                       readOnly={curval.value === "1"}
                                       onChange={e=> {
                                        setCurval({...curval, value : floattest.test(e.target.value) ? e.target.value : "0"})
                                       }}
                                     
                                   />
                                   <InputGroupText>
                                      {curval.symbol}
                                   </InputGroupText>
                               </InputGroup>
                             </FormGroup>
                            
                                </Col>
                                <Col md="4">
                                <FormGroup>
                            <Button color = "primary" style={{marginTop : 25}} 
                            onClick={x => {
                                cinputConfirmAlert(curval.cid)
                            }}>Update</Button>
                            </FormGroup>
                                </Col>
                            </Row>
                         

                            </Col>
                          


                            <Col>
                                <Table>
                                    <thead>
                                        <tr>
                                        <th style={{textAlign : "center"}}>CID</th>
                                        <th style={{textAlign : "center"}}>Country</th>
                                        <th style={{textAlign : "center"}}>Name</th>
                                        <th style={{textAlign : "center"}}>Symbol</th>
                                        <th style={{textAlign : "center"}}>Value</th>
                         
                                        </tr>
                                    </thead>
                                       
                                    <tbody>
                                        {
                                                curlist.length >= 1 && curlist.map((x, key) => {
                                                    return (
                                                        <tr key={key} >
                                                            <td  style={{textAlign : "center"}}>{x.value}</td>
                                                            <td style={{textAlign : "center"}}>{x.country}</td>
                                                            <td style={{textAlign : "center"}}>{x.name}</td>
                                                            <td style={{textAlign : "center"}}>{x.symbol}</td>
                                                            <td style={{textAlign : "center"}}>{x.amount}</td>
                                                        </tr>
                                                    )
                                                })
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    </Col>
                </Row>
                </div>
             
    
    
                
      
    </>
  );
}

export default Currency;
